<template>
    <div v-cloak>
        <span v-if="readOnly">
            {{ deliveryType }}
        </span>
        <div v-else>
            <b-btn
                :id="code+fieldName+enrolmentId"
                ref="button"
                :disabled="popoverShow"
                variant="outline-secondary"
                size="sm"
            >
                {{ deliveryType }}
            </b-btn>

            <b-popover
                ref="popover"
                :target="code+fieldName+enrolmentId"
                triggers="click"
                :show.sync="popoverShow"
                placement="auto"
                container="myContainer"
                @show="onShow"
                @hidden="onHidden"
            >
                <template slot="title">
                    <b-btn
                        aria-label="Close"
                        class="close"
                        @click="onClose"
                    >
                        <span
                            class="d-inline-block"
                            aria-hidden="true"
                        >
                            &times;
                        </span>
                    </b-btn>
                    {{ code }} - {{ description }}
                </template>

                <b-alert
                    variant="danger"
                    dismissible
                    :show="error"
                    @dismissed="showDismissibleAlert=false"
                >
                    {{ description }} is required!
                </b-alert>

                <b-form-select v-model="currentValue">
                    <option disabled value="">Please select one</option>
                    <option value="1">
                        RTO
                    </option>
                    <option value="2">
                        WBD
                    </option>
                    <option value="3">
                        BOTH
                    </option>
                </b-form-select>

                <level-selector
                    ref="currentValue"
                    @bulk-levels="setLevels"
                />

                <b-btn
                    variant="danger"
                    @click="onClose"
                >
                    Cancel
                </b-btn>
                <b-btn
                    :disabled="!currentValue"
                    variant="primary"
                    @click="onOk"
                >
                    Save
                </b-btn>
            </b-popover>
        </div>
    </div>
</template>

<script>
import LevelSelector from './LevelSelector.vue';
/* global Noty */
/* global axios */
export default {
    name: 'DeliveryTypeBulk',
    components: {
        LevelSelector,
    },
    props: {
        enrolmentId: {
            type: Number,
            required: true,
        },
        code: {
            type: String,
            required: true,
        },
        fieldName: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        oldValue: {
            type: Number,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            actualSelectedLevels: [],
            popoverShow: false,
            currentValue: this.oldValue,
            error: false,
        };
    },
    computed: {
        deliveryType() {
            switch (Number(this.oldValue)) {
            case 1:
                return 'RTO';
            case 2:
                return 'WBD';
            case 3:
                return 'BOTH';
            default:
                return '';
            }
        },
    },
    watch: {
        currentValue() {
            if (this.currentValue) {
                this.error = false;
            }
        },
    },
    methods: {
        setLevels(levels) {
            this.actualSelectedLevels = levels;
        },
        onClose() {
            this.popoverShow = false;
        },
        onHidden() {
            this.currentValue = this.oldValue;
            this.$refs.currentValue.resetLevels();
            this.error = false;
        },
        onOk() {
            if (this.currentValue) {
                this.updateCurrentValue();
                this.onClose();
            } else {
                this.error = true;
            }
        },
        onShow() {
            this.currentValue = this.oldValue;
        },
        updateCurrentValue() {
            this.isLoading = true;
            axios
                .patch(`/api/enrolmentsBulkUpdate/${this.enrolmentId}`, {
                    levels: this.actualSelectedLevels,
                    fieldName: this.fieldName,
                    currentValue: Number(this.currentValue),
                })
                .then(() => {
                    this.$emit('refreshData');
                    this.isLoading = false;

                    const n = new Noty({
                        text: `${this.description} updated!`,
                        type: 'success',
                        modal: false,
                    });
                    n.show();
                })
                .catch((error) => {
                    new Noty({
                        text: error.response.data.message,
                        type: 'error',
                        timeout: 1000,
                    }).show();
                });
        },
    },
};
</script>

<style>
    .popover {
        max-width: 325px !important;
    }
</style>
